import { Pipe, PipeTransform } from '@angular/core';

export enum SortingStatus {
  ASC,
  DESC,
  DISABLED,
}

@Pipe({
  name: 'tableSorting',
  pure: true,
})
export class TableSortingPipe implements PipeTransform {

  transform(objectList: Record<string, any>[], order: SortingStatus = SortingStatus.DISABLED, column: string = ''): Record<string, any>[] {
    const originalArray = <typeof objectList>JSON.parse(JSON.stringify(objectList));

    let columnToSort = column;
    if (!objectList) return objectList; // no array
    if (objectList.length <= 1) return objectList; // array with only one item

    if (!columnToSort || columnToSort === '') {
      [columnToSort] = Object.keys(objectList[0]);
    }

    const isNumericData = objectList.some((obj) => !Number.isNaN(+obj[columnToSort]));

    const isDate = objectList.some((obj) => isValidDate(obj[columnToSort]));

    if (order === SortingStatus.DESC) {
      if (isNumericData && !isDate) {
        return originalArray.sort((previousList, currentList) => currentList[columnToSort] - previousList[columnToSort]);
      }

      return originalArray.sort((previousList, currentList) => (currentList[columnToSort] > previousList[columnToSort] ? 1 : -1));
    }
    if (order === SortingStatus.ASC) {
      if (isNumericData && !isDate) {
        return originalArray.sort((previousList, currentList) => previousList[columnToSort] - currentList[columnToSort]);
      }
      return originalArray.sort((previousList, currentList) => (previousList[columnToSort] > currentList[columnToSort] ? 1 : -1));
    }

    return objectList;
  }

}

function isValidDate(d: Date) {
  return d instanceof Date && !Number.isNaN(d);
}
